import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PluginShareTransferMainAppComponent } from './components/main/main.component';

export const shareTransferAppRoutes : Routes = [
    {
        path: 'p/transfer/:project',
        component: PluginShareTransferMainAppComponent,

    },
];

@NgModule({
  imports: [RouterModule.forChild(shareTransferAppRoutes)],
  exports: [RouterModule]
})
export class ShareTransferAppRouterModule { }
